import React, { useEffect, useMemo, useRef, useState } from 'react';
import jwtDecode from 'jwt-decode';
import { useAppConfig } from '@jwp/ott-hooks-react/src/useAppConfig';
import useQueryParam from '../../hooks/useQueryParam';
import { useAppInfo } from '@jwp/ott-hooks-react/src/useAppInfo';
import useCheckout from '@jwp/ott-hooks-react/src/useCheckout';
import ReactGA from 'react-ga4';
import { useAccountStore } from '@jwp/ott-common/src/stores/AccountStore';
import { useGADeviceType } from '@jwp/ott-common/src/utils/GADeviceType';

import './CleengCheckout.modules.scss';
import { sendGAEvent } from '@jwp/ott-hooks-react/src/useAnalytics';

declare global {
  interface Window {
    cleeng?: {
      setAuthTokens: (tokens: { jwt: string; refreshToken: string }) => void;
      onAuthTokensUpdate: (callback: (tokens: { jwt: string; refreshToken: string }) => void) => void;
    };
  }
}

export const CleengCheckout: React.FC = () => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const { isSubscriptionEnabled, isGoogleAnalytics, subscription_type } = useAppConfig();
  const offerId = useQueryParam('offerId');
  const user = useAccountStore((state) => state.user);
  const isLoggedIn = !!user;
  const userId = isLoggedIn ? user.id : 'Guest user';
  const deviceType = true ? useGADeviceType() : null;

  const storedAuth = useMemo(() => {
    try {
      const data = localStorage.getItem('jwapp.auth');
      return data ? JSON.parse(data) : null;
    } catch (e) {
      console.error('Failed to parse auth from localStorage:', e);
      return null;
    }
  }, []);

  const authToken = storedAuth?.accessToken ?? null;
  const refreshToken = storedAuth?.refreshToken ?? null;

  const publisherId = useMemo(() => {
    try {
      return authToken ? jwtDecode<{ publisherId: string }>(authToken).publisherId : null;
    } catch (error) {
      console.error('JWT decode failed:', error);
      return null;
    }
  }, [authToken]);

  const { selectedOffer } = useCheckout({
    onUpdateOrderSuccess: () => {},
    onSubmitPaymentWithoutDetailsSuccess: () => {},
    onSubmitPaypalPaymentSuccess: () => {},
    onSubmitStripePaymentSuccess: () => {},
    onSubmitPaymentWithoutDetailsFailure: () => {},
    onSubmitPaypalPaymentFailure: () => {},
    onSubmitStripePaymentFailure: () => {},
  });

  useEffect(() => {
    if (!selectedOffer) {
      return;
    }
    if (isGoogleAnalytics) {
      sendGAEvent('paywall_view', {
        asset_id: selectedOffer?.offerId,
        title: selectedOffer?.offerTitle,
        price: selectedOffer?.offerPrice,
        currency: selectedOffer?.offerCurrency,
        provider: subscription_type,
        userid_no: userId,
        device_type: deviceType,
      });
    }
  }, [selectedOffer]);

  useEffect(() => {
    const handleCleengMessage = async (event: MessageEvent) => {
      // console.log('Cleeng message received:', event.origin, window.location.origin);
      // if (event.origin !== window.location.origin) return;
      // if (domain?.includes(document.location.host)) {
      // console.log('Cleeng message data:', event.data);
      // if (event.data?.type === 'CLEENG_SDK_LOADED' || event.data?.type === 'CLEENG_WIDGETS_LOADED') {
      // if (window.cleeng?.setAuthTokens) {
      //   await window.cleeng.setAuthTokens({
      //     jwt: authToken,
      //     refreshToken,
      //   });
      // }

      // await window.cleeng?.onAuthTokensUpdate?.(({ jwt, refreshToken }) => {
      //   console.log('Cleeng auth tokens updated:', jwt, refreshToken);
      //   // localStorage.setItem('jwapp.auth', JSON.stringify({ ...storedAuth, accessToken: jwt, refreshToken }));
      // });
      // }
      // }

      window.addEventListener('message', handleCleengMessage);

      return () => {
        window.removeEventListener('message', handleCleengMessage);
      };
    };

    window.addEventListener('message', handleCleengMessage);

    return () => {
      window.removeEventListener('message', handleCleengMessage);
      // document.body.removeChild(script);
    };
  }, [authToken, refreshToken]);

  useEffect(() => {
    if (!offerId || !isSubscriptionEnabled) {
      window.location.href = '/';
    }
  }, [offerId]);

  return (
    <>
      <div
        ref={widgetRef}
        data-cleeng-widget="checkout"
        data-cleeng-publisher-id={publisherId}
        data-cleeng-offer-id={offerId}
        // data-cleeng-auth-token={authToken}
        // data-cleeng-refresh-token={refreshToken}
        className="cleeng-checkout-widget"
      />
    </>
  );
};
